import React, { FC } from "react";
import clsx from "clsx";

import Hero from "./Hero";
import Step from "./Step";
import Summary from "./Summary";
import styles from "./CareerReference.module.scss";

type Props = {
  createCareerSheets: () => void;
  onOpenChallengeSheet: () => void;
};

const CareerReference: FC<Props> = ({
  createCareerSheets,
  onOpenChallengeSheet,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={clsx(styles.section, styles.hero)}>
        <div className={styles.inner}>
          <Hero />
        </div>
      </div>
      <div className={clsx(styles.section, styles.step)}>
        <div className={styles.inner}>
          <Step />
        </div>
      </div>
      <div className={clsx(styles.section, styles.summary)}>
        <div className={styles.inner}>
          <Summary
            createCareerSheets={createCareerSheets}
            onOpenChallengeSheet={onOpenChallengeSheet}
          />
        </div>
      </div>
    </div>
  );
};

export default CareerReference;
